module.exports = __webpack_public_path__ + "media/images/copy-icon-27ebe79b217cb0e1e86c1c2a8a1bf2aa.svg";